function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.94c1.834 0 3.362-1.627 3.362-3.71C11.362 2.196 9.826.62 8 .62S4.622 2.22 4.63 4.246C4.63 6.313 6.166 7.94 8 7.94zm-5.495 7.745h10.982c.963 0 1.544-.465 1.544-1.229 0-2.133-2.731-5.055-7.04-5.055-4.3 0-7.03 2.922-7.03 5.056 0 .763.581 1.228 1.544 1.228z",
    fill: "#000"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-booking-passenger.svg";